import LayoutContentStyle from './LayoutContent.style';

const LayoutContent = ({ children, ...props }) => (
  <LayoutContentStyle {...props}>{children}</LayoutContentStyle>
);

export default LayoutContent;
